(function () {
    'use strict';

    if (window.DFN_FINDER_BOOTSTRAPPED) return;
    window.DFN_FINDER_BOOTSTRAPPED = true;

    const API_BASE = '/apps/tecdoc';
    const STORAGE_KEY = 'dfn_vehicle';
    const CLIENT_ID_KEY = 'dfn_tecdoc_client_id';
    const REQUEST_CACHE_PREFIX = 'dfn_request_cache:';
    const PERSISTED_CACHE_TTL = 15 * 60 * 1000;
    const MEMORY_CACHE_TTL = 2 * 60 * 1000;
    const requestCache = new Map();
    const inflightRequests = new Map();
    let turnstileScriptPromise = null;

    function getClientId() {
        try {
            const existing = localStorage.getItem(CLIENT_ID_KEY);
            if (existing) return existing;
            const created = window.crypto && typeof window.crypto.randomUUID === 'function'
                ? window.crypto.randomUUID()
                : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
            localStorage.setItem(CLIENT_ID_KEY, created);
            return created;
        } catch (_) {
            return 'anonymous';
        }
    }

    function loadTurnstile() {
        if (window.turnstile) return Promise.resolve(window.turnstile);
        if (turnstileScriptPromise) return turnstileScriptPromise;
        turnstileScriptPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            script.async = true;
            script.defer = true;
            script.onload = () => resolve(window.turnstile);
            script.onerror = () => reject(new Error('Verification could not be loaded.'));
            document.head.appendChild(script);
        });
        return turnstileScriptPromise;
    }

    async function requestTurnstileToken(siteKey) {
        const turnstile = await loadTurnstile();
        if (!turnstile || !siteKey) throw new Error('Verification is unavailable.');
        const language = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
        const copy = language === 'fr'
            ? ['Vérification rapide', 'Veuillez confirmer que vous êtes une personne pour poursuivre la recherche.', 'Annuler']
            : language === 'en'
                ? ['Quick verification', 'Please confirm you are human to continue the registration search.', 'Cancel']
                : ['Kurze Überprüfung', 'Bitte bestätigen Sie, dass Sie ein Mensch sind, um die Kennzeichensuche fortzusetzen.', 'Abbrechen'];

        return new Promise((resolve, reject) => {
            const overlay = document.createElement('div');
            overlay.setAttribute('role', 'dialog');
            overlay.setAttribute('aria-modal', 'true');
            overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:20px;background:rgba(0,0,0,.5)';
            const panel = document.createElement('div');
            panel.style.cssText = 'width:min(100%,420px);padding:24px;border-radius:16px;background:#fff;color:#111;box-shadow:0 20px 60px rgba(0,0,0,.25);text-align:center';
            const title = document.createElement('strong');
            title.textContent = copy[0];
            title.style.cssText = 'display:block;margin-bottom:8px;font-size:18px';
            const message = document.createElement('p');
            message.textContent = copy[1];
            message.style.cssText = 'margin:0 0 16px';
            const widget = document.createElement('div');
            widget.style.cssText = 'display:flex;justify-content:center;min-height:65px';
            const cancel = document.createElement('button');
            cancel.type = 'button';
            cancel.textContent = copy[2];
            cancel.style.cssText = 'margin-top:14px;border:0;background:transparent;text-decoration:underline;cursor:pointer';
            panel.append(title, message, widget, cancel);
            overlay.appendChild(panel);
            document.body.appendChild(overlay);

            let widgetId = null;
            const cleanup = () => {
                if (widgetId !== null) turnstile.remove(widgetId);
                overlay.remove();
            };
            cancel.addEventListener('click', () => {
                cleanup();
                reject(new Error(copy[2]));
            });
            widgetId = turnstile.render(widget, {
                sitekey: siteKey,
                action: 'plate_lookup',
                theme: 'auto',
                size: 'flexible',
                callback(token) {
                    cleanup();
                    resolve(token);
                },
                'error-callback'() {
                    cleanup();
                    reject(new Error('Verification failed.'));
                }
            });
        });
    }

    function qs(root, selector) {
        return root ? root.querySelector(selector) : null;
    }

    function qsa(root, selector) {
        return root ? Array.from(root.querySelectorAll(selector)) : [];
    }

    function esc(value) {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function initHomeMediaSlider(media) {
        if (!media || media.dataset.dfnMediaSliderReady === 'true') return;

        const slides = qsa(media, '.dfn-home-finder__media-slide');
        if (slides.length < 2) return;

        media.dataset.dfnMediaSliderReady = 'true';

        const prevButton = qs(media, '[data-dfn-media-prev]');
        const nextButton = qs(media, '[data-dfn-media-next]');
        const dotButtons = qsa(media, '[data-dfn-media-dot]');
        const captionRoot = media.parentElement ? qs(media.parentElement, '[data-dfn-media-captions]') : null;
        const captions = qsa(captionRoot, '.dfn-home-finder__media-caption-slide');
        let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
        let timer = null;

        function showSlide(index) {
            activeIndex = (index + slides.length) % slides.length;
            slides.forEach((slide, slideIndex) => {
                slide.classList.toggle('is-active', slideIndex === activeIndex);
            });
            captions.forEach((caption, captionIndex) => {
                caption.classList.toggle('is-active', captionIndex === activeIndex);
            });
            dotButtons.forEach((button, dotIndex) => {
                const isActive = dotIndex === activeIndex;
                button.classList.toggle('is-active', isActive);
                button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
        }

        function stopAuto() {
            if (!timer) return;
            window.clearInterval(timer);
            timer = null;
        }

        function startAuto() {
            stopAuto();
            timer = window.setInterval(() => showSlide(activeIndex + 1), 5500);
        }

        function moveSlide(index) {
            showSlide(index);
            startAuto();
        }

        if (prevButton) {
            prevButton.addEventListener('click', () => moveSlide(activeIndex - 1));
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => moveSlide(activeIndex + 1));
        }

        dotButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const targetIndex = Number(button.dataset.dfnMediaDot || 0);
                moveSlide(Number.isFinite(targetIndex) ? targetIndex : 0);
            });
        });

        media.addEventListener('mouseenter', stopAuto);
        media.addEventListener('mouseleave', startAuto);
        media.addEventListener('focusin', stopAuto);
        media.addEventListener('focusout', startAuto);

        showSlide(activeIndex);
        startAuto();
    }

    function bindSelectChevronState(root) {
        qsa(root, '.dfn-locator__field select').forEach((select) => {
            const field = select.closest('.dfn-locator__field');
            if (!field || select.dataset.dfnChevronReady === 'true') return;

            select.dataset.dfnChevronReady = 'true';

            const close = () => field.classList.remove('is-select-open');

            select.addEventListener('pointerdown', () => {
                if (select.disabled) {
                    close();
                    return;
                }

                field.classList.toggle('is-select-open');
            });

            select.addEventListener('change', close);
            select.addEventListener('blur', close);
            select.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' || event.key === 'Enter' || event.key === 'Tab') {
                    window.setTimeout(close, 0);
                }
            });
        });
    }

    function readSessionCache(key) {
        try {
            const raw = sessionStorage.getItem(`${REQUEST_CACHE_PREFIX}${key}`);
            if (!raw) return null;

            const parsed = JSON.parse(raw);
            if (!parsed || parsed.expiresAt <= Date.now()) {
                sessionStorage.removeItem(`${REQUEST_CACHE_PREFIX}${key}`);
                return null;
            }

            return parsed.value;
        } catch (_) {
            return null;
        }
    }

    function writeSessionCache(key, value, ttl) {
        try {
            sessionStorage.setItem(`${REQUEST_CACHE_PREFIX}${key}`, JSON.stringify({
                value,
                expiresAt: Date.now() + ttl
            }));
        } catch (_) { }
    }

    function getCachePolicy(path) {
        if (
            path.startsWith('/makes?')
            || path.startsWith('/models?')
            || path.startsWith('/vehicles?')
            || path.startsWith('/vehicle-results?')
        ) {
            return { ttl: PERSISTED_CACHE_TTL, persist: true };
        }

        if (path.startsWith('/hsn-tsn?') || path.startsWith('/plate?')) {
            return { ttl: MEMORY_CACHE_TTL, persist: false };
        }

        return null;
    }

    function createApiError(response, json, fallbackMessage) {
        const error = new Error((json && json.error) || fallbackMessage || 'API error');
        error.status = response && typeof response.status === 'number' ? response.status : 0;
        error.code = json && json.code ? json.code : '';
        error.turnstileSiteKey = json && json.turnstileSiteKey ? json.turnstileSiteKey : '';
        error.isApiError = true;
        return error;
    }

    function isConnectionError(error) {
        const message = String(error && error.message || '').toLowerCase();
        return error instanceof TypeError
            || message.includes('failed to fetch')
            || message.includes('networkerror')
            || message.includes('load failed');
    }

    function isTechnicalApiMessage(message) {
        const value = String(message || '').toLowerCase();
        return value.startsWith('api error')
            || value.includes('http ')
            || value.includes('rate limit')
            || value.includes('too many requests');
    }

    function resolveUserErrorMessage(root, error, fallback) {
        const status = Number(error && error.status || 0);
        const message = String(error && error.message || '').trim();

        if (status === 429 || /(^|\D)429(\D|$)/.test(message) || /rate limit|too many requests/i.test(message)) {
            return readText(root, 'apiBusyText', 'Gerade sind zu viele Anfragen offen. Bitte versuchen Sie es in wenigen Sekunden erneut.');
        }

        if (status >= 500 || status === 401 || status === 403) {
            return readText(root, 'apiUnavailableText', 'Der Fahrzeugservice antwortet gerade nicht. Bitte versuchen Sie es in wenigen Minuten erneut.');
        }

        if (status === 404) {
            return readText(root, 'apiNotFoundText', 'Dazu konnten wir gerade keine Daten laden. Bitte pruefen Sie Ihre Eingabe und versuchen Sie es erneut.');
        }

        if (isConnectionError(error)) {
            return readText(root, 'apiConnectionText', 'Die Verbindung zum Fahrzeugservice ist gerade unterbrochen. Bitte versuchen Sie es erneut.');
        }

        if (error && error.isApiError) {
            return readText(root, 'apiGenericText', fallback || 'Die Daten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.');
        }

        if (isTechnicalApiMessage(message)) {
            return readText(root, 'apiGenericText', fallback || 'Die Daten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.');
        }

        return message || fallback || readText(root, 'apiGenericText', 'Die Daten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.');
    }

    function readText(root, key, fallback) {
        const value = root && root.dataset ? root.dataset[key] : '';
        return typeof value === 'string' && value.trim() !== '' ? value.trim() : fallback;
    }

    function formatText(template, replacements) {
        return Object.entries(replacements || {}).reduce((acc, [key, value]) => {
            return acc.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value == null ? '' : value));
        }, template || '');
    }

    function toCollectionSlug(value) {
        return String(value || '')
            .trim()
            .replace(/ß/g, 'ss')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-zA-Z0-9]+/g, '-')
            .replace(/-{2,}/g, '-')
            .replace(/^-|-$/g, '')
            .toLowerCase();
    }

    function getConfig(root) {
        return {
            storeId: root.dataset.storeId || 'main-store',
            family: root.dataset.family || '',
            language: root.dataset.language || 'de',
            profile: root.dataset.tecDocProfile || 'de',
            plateCountry: (root.dataset.plateCountry || '').toUpperCase(),
            routeSlug: root.dataset.routeSlug || 'einspritzdusen',
            resultsPageUrl: root.dataset.resultsPageUrl || ''
        };
    }

    function getSelectedFamily(root, vehicle) {
        const familySelect = qs(root, '[data-dfn-role="family-select"]');
        if (familySelect) {
            const selectedOption = familySelect.selectedOptions && familySelect.selectedOptions[0];
            return (selectedOption && selectedOption.dataset ? selectedOption.dataset.familySlug : '')
                || familySelect.value
                || '';
        }
        if (vehicle && vehicle.family) return vehicle.family;
        return getConfig(root).family || '';
    }

    function normalizeFamily(value) {
        return String(value || '').trim().toLowerCase();
    }

    function setSelectedFamily(root, family) {
        const familySelect = qs(root, '[data-dfn-role="family-select"]');
        const selectedFamily = normalizeFamily(family);
        if (!familySelect || !selectedFamily) return;

        const matchedOption = qsa(familySelect, 'option').find((option) => {
            if (option.disabled || option.hidden) return false;
            const slug = normalizeFamily(option.dataset ? option.dataset.familySlug : '');
            const value = normalizeFamily(option.value);
            return slug === selectedFamily || value === selectedFamily;
        });

        if (matchedOption) {
            familySelect.value = matchedOption.value;
        }
    }

    function getVehicleImageSrc(vehicle) {
        const imageUrl = vehicle && (vehicle.imageUrl || vehicle.ImageUrl || '');
        if (!imageUrl) return '';

        return `${API_BASE}/vehicle-image?url=${encodeURIComponent(imageUrl)}`;
    }

    function saveVehicle(vehicle) {
        const payload = { ...vehicle, savedAt: Date.now() };

        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        } catch (_) { }

        document.dispatchEvent(new CustomEvent('dfn:vehicle-selected', { detail: payload }));
    }

    function clearVehicle() {
        try {
            localStorage.removeItem(STORAGE_KEY);
        } catch (_) { }

        document.dispatchEvent(new CustomEvent('dfn:vehicle-cleared'));
    }

    function loadVehicle() {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch (_) {
            return null;
        }
    }

    function vehicleMatchesConfig(vehicle, config) {
        if (!vehicle || !config) return false;
        if (vehicle.storeId && vehicle.storeId !== config.storeId) return false;
        if (vehicle.tecDocProfile && vehicle.tecDocProfile !== config.profile) return false;
        return true;
    }

    function loadVehicleForConfig(config) {
        const vehicle = loadVehicle();
        return vehicleMatchesConfig(vehicle, config) ? vehicle : null;
    }

    async function apiFetch(path) {
        const cachePolicy = getCachePolicy(path);
        const cacheKey = path;

        if (cachePolicy) {
            const cached = requestCache.get(cacheKey);
            if (cached && cached.expiresAt > Date.now()) {
                return cached.value;
            }

            if (cachePolicy.persist) {
                const persisted = readSessionCache(cacheKey);
                if (persisted) {
                    requestCache.set(cacheKey, { value: persisted, expiresAt: Date.now() + cachePolicy.ttl });
                    return persisted;
                }
            }

            if (inflightRequests.has(cacheKey)) {
                return inflightRequests.get(cacheKey);
            }
        }

        const request = (async () => {
            const response = await fetch(`${API_BASE}${path}`);
            let json = null;

            try {
                json = await response.json();
            } catch (_) {
                json = null;
            }

            if (!response.ok) {
                throw createApiError(response, json, `API error ${response.status}`);
            }

            if (!json || json.success === false) {
                throw createApiError(response, json, 'API error');
            }

            const data = json.data;

            if (cachePolicy) {
                requestCache.set(cacheKey, { value: data, expiresAt: Date.now() + cachePolicy.ttl });
                if (cachePolicy.persist) {
                    writeSessionCache(cacheKey, data, cachePolicy.ttl);
                }
            }

            return data;
        })().finally(() => {
            if (cachePolicy) inflightRequests.delete(cacheKey);
        });

        if (cachePolicy) {
            inflightRequests.set(cacheKey, request);
        }

        return request;
    }

    function buildParams(root, extra) {
        const config = getConfig(root);
        const params = new URLSearchParams({
            lang: config.language,
            storeId: config.storeId,
            tecDocProfile: config.profile
        });

        Object.entries(extra || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null && `${value}` !== '') {
                params.set(key, String(value));
            }
        });

        return params;
    }

    function getMakes(root) {
        return apiFetch(`/makes?${buildParams(root).toString()}`);
    }

    function getModels(root, makeId) {
        return apiFetch(`/models?${buildParams(root, { makeId }).toString()}`);
    }

    function getVehicles(root, makeId, modelSeriesId) {
        return apiFetch(`/vehicles?${buildParams(root, { makeId, modelSeriesId }).toString()}`);
    }

    function searchHsnTsn(root, hsn, tsn) {
        return apiFetch(`/hsn-tsn?${buildParams(root, { hsn, tsn }).toString()}`);
    }

    async function searchPlate(root, plate) {
        const config = getConfig(root);
        const country = config.plateCountry || 'FR';
        const normalizedPlate = country === 'IE'
            ? plate.replace(/[\s-]+/g, '')
            : plate;
        const params = buildParams(root, { plate: normalizedPlate, country, clientId: getClientId() });
        try {
            return await apiFetch(`/plate?${params.toString()}`);
        } catch (error) {
            if (!error || error.code !== 'turnstile_required' || !error.turnstileSiteKey) throw error;
            params.set('turnstileToken', await requestTurnstileToken(error.turnstileSiteKey));
            return apiFetch(`/plate?${params.toString()}`);
        }
    }

    function getVehicleResultSummary(root, vehicleId) {
        const config = getConfig(root);
        const params = new URLSearchParams({
            vehicleId: String(vehicleId),
            storeId: config.storeId,
            tecDocProfile: config.profile,
            page: '1',
            limit: '12'
        });

        return apiFetch(`/vehicle-results?${params.toString()}`);
    }

    function setStatus(element, text, tone) {
        if (!element) return;

        element.textContent = text || '';
        element.classList.remove('is-error', 'is-success');

        if (tone === 'error') element.classList.add('is-error');
        if (tone === 'success') element.classList.add('is-success');
    }

    function setBusy(element, isBusy) {
        if (!element) return;
        if ('disabled' in element) element.disabled = !!isBusy;
        element.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    function bindSubmitOnEnter(inputs, handler) {
        (inputs || []).filter(Boolean).forEach((input) => {
            input.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter') return;
                event.preventDefault();
                handler();
            });
        });
    }

    function fillSelect(select, placeholder, items, getValue, getLabel) {
        if (!select) return;

        select.innerHTML = '';

        const placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = placeholder;
        select.appendChild(placeholderOption);

        (items || []).forEach((item) => {
            const option = document.createElement('option');
            option.value = String(getValue(item));
            option.textContent = getLabel(item);
            select.appendChild(option);
        });
    }

    function vehicleLabel(vehicle) {
        return [
            vehicle.typeName,
            vehicle.engineCode,
            vehicle.powerHp ? `${vehicle.powerHp} PS` : '',
            vehicle.yearFrom ? `${vehicle.yearFrom}-${vehicle.yearTo || '>'}` : ''
        ].filter(Boolean).join(' · ');
    }

    function vehicleDisplayName(vehicle) {
        return [
            vehicle.makeName,
            vehicle.modelName,
            vehicleLabel(vehicle)
        ].filter(Boolean).join(' ');
    }

    function buildResultsUrl(root, vehicle) {
        const config = getConfig(root);
        const selectedFamily = getSelectedFamily(root, vehicle);

        if (config.resultsPageUrl) {
            const url = new URL(config.resultsPageUrl, window.location.origin);
            url.searchParams.set('vehicleId', String(vehicle.id || vehicle.vehicleId));
            url.searchParams.set('storeId', config.storeId);
            if (selectedFamily) {
                url.searchParams.set('family', selectedFamily);
            } else {
                url.searchParams.delete('family');
            }
            url.searchParams.set('tecDocProfile', config.profile);
            return `${url.pathname}${url.search}`;
        }

        const routeSlug = selectedFamily || config.routeSlug;
        const makeSlug = toCollectionSlug(vehicle.makeName);
        const modelSlug = toCollectionSlug(vehicle.modelName);

        if (makeSlug && modelSlug) {
            return `/collections/${routeSlug}-${makeSlug}-${modelSlug}`;
        }

        if (makeSlug) {
            return `/collections/${routeSlug}-${makeSlug}`;
        }

        return `/collections/${routeSlug}`;
    }

    function firstLetter(value, fallback) {
        const source = String(value || fallback || '').trim();
        return source ? source.charAt(0).toUpperCase() : 'F';
    }

    function renderVehicleResults(root, target, statusElement, vehicles, countText) {
        if (!target) return;

        const config = getConfig(root);

        target.innerHTML = '';

        if (!vehicles || !vehicles.length) {
            return;
        }

        setStatus(statusElement, formatText(countText, { count: vehicles.length }), 'success');

        vehicles.forEach((vehicle) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'dfn-locator__result-item';
            const vehicleImage = getVehicleImageSrc(vehicle);
            const fallbackLetter = firstLetter(vehicle.makeName, 'F');
            button.innerHTML = `
        <span class="dfn-locator__result-media">
          ${vehicleImage
                    ? `<img src="${esc(vehicleImage)}" alt="${esc(vehicleDisplayName(vehicle))}" width="48" height="48" loading="lazy">`
                    : `<span class="dfn-locator__result-fallback">${esc(fallbackLetter)}</span>`}
        </span>
        <span class="dfn-locator__result-copy">
          <strong>${esc(vehicle.makeName || '')} ${esc(vehicle.modelName || '')}</strong>
          <span>${esc(vehicleLabel(vehicle))}</span>
        </span>`;
            button.addEventListener('click', () => {
                saveVehicle({
                    ...vehicle,
                    vehicleId: vehicle.id,
                    makeId: vehicle.makeId || vehicle.manufacturerId || '',
                    modelId: vehicle.modelSeriesId,
                    storeId: config.storeId,
                    family: getSelectedFamily(root, vehicle),
                    tecDocProfile: config.profile,
                    vehicleName: vehicleLabel(vehicle)
                });
                window.location.href = buildResultsUrl(root, vehicle);
            });
            target.appendChild(button);
        });
    }

    function activateTab(root, tabName) {
        const tabs = qsa(root, '[data-dfn-tab]');
        const panels = qsa(root, '[data-dfn-panel]');

        tabs.forEach((button) => {
            button.classList.toggle('is-active', button.dataset.dfnTab === tabName);
        });

        panels.forEach((panel) => {
            panel.classList.toggle('dfn-hidden', panel.dataset.dfnPanel !== tabName);
        });
    }

    async function initFinder(root) {
        if (!root || root.dataset.dfnFinderReady === 'true') return;
        root.dataset.dfnFinderReady = 'true';

        const config = getConfig(root);
        const makeSelect = qs(root, '[data-dfn-role="make-select"]');
        const modelSelect = qs(root, '[data-dfn-role="model-select"]');
        const vehicleSelect = qs(root, '[data-dfn-role="vehicle-select"]');
        const confirmButton = qs(root, '[data-dfn-role="confirm"]');
        const clearButton = qs(root, '[data-dfn-role="clear"]');
        const vehicleStatus = qs(root, '[data-dfn-role="vehicle-status"]');
        const hsnInput = qs(root, '[data-dfn-role="hsn-input"]');
        const tsnInput = qs(root, '[data-dfn-role="tsn-input"]');
        const hsnButton = qs(root, '[data-dfn-role="hsn-search"]');
        const hsnStatus = qs(root, '[data-dfn-role="hsn-status"]');
        const hsnResults = qs(root, '[data-dfn-role="hsn-results"]');
        const plateInput = qs(root, '[data-dfn-role="plate-input"]');
        const plateButton = qs(root, '[data-dfn-role="plate-search"]');
        const plateStatus = qs(root, '[data-dfn-role="plate-status"]');
        const plateResults = qs(root, '[data-dfn-role="plate-results"]');
        const loadingMask = qs(root, '[data-dfn-role="loading-mask"]');
        const vehiclePreview = qs(root, '[data-dfn-role="vehicle-preview"]');
        const vehiclePreviewText = qs(root, '[data-dfn-role="vehicle-preview-text"]');
        const vehiclePreviewImage = qs(root, '[data-dfn-role="vehicle-preview-image"]');
        const vehiclePreviewFallback = qs(root, '[data-dfn-role="vehicle-preview-fallback"]');
        const productFilter = qs(root, '[data-dfn-role="product-filter"]');
        const familySelect = qs(root, '[data-dfn-role="family-select"]');
        const vehicleSteps = qsa(root, '[data-dfn-step]');

        const state = {
            makes: [],
            models: [],
            vehicles: [],
            familyRequestId: 0,
            loadingCount: 0,
            hsnSearchPending: false,
            plateSearchPending: false
        };

        bindSelectChevronState(root);

        function isCompatibleVehicle(vehicle) {
            return vehicleMatchesConfig(vehicle, config);
        }

        function updateVehicleSteps() {
            if (!vehicleSteps.length) return;

            const hasMake = Boolean(makeSelect && makeSelect.value);
            const hasModel = Boolean(modelSelect && modelSelect.value);
            const hasVehicle = Boolean(vehicleSelect && vehicleSelect.value);

            vehicleSteps.forEach((step) => {
                const stepName = step.dataset.dfnStep;
                const isComplete =
                    (stepName === 'make' && hasMake) ||
                    (stepName === 'model' && hasModel) ||
                    (stepName === 'vehicle' && hasVehicle);
                const isActive =
                    (stepName === 'make' && !hasMake) ||
                    (stepName === 'model' && hasMake && !hasModel) ||
                    (stepName === 'vehicle' && hasModel && !hasVehicle);

                step.classList.toggle('is-complete', isComplete);
                step.classList.toggle('is-active', isActive);

                if (isActive) {
                    step.setAttribute('aria-current', 'step');
                } else {
                    step.removeAttribute('aria-current');
                }
            });
        }

        function resetVehicleTree() {
            if (makeSelect) makeSelect.value = '';

            if (modelSelect) {
                fillSelect(modelSelect, readText(root, 'modelPlaceholder', 'Modell wählen'), [], (item) => item.id, (item) => item.name);
                modelSelect.disabled = true;
            }

            if (vehicleSelect) {
                fillSelect(vehicleSelect, readText(root, 'vehiclePlaceholder', 'Motor / Typ wählen'), [], (item) => item.id, vehicleLabel);
                vehicleSelect.disabled = true;
            }

            state.models = [];
            state.vehicles = [];

            if (confirmButton) confirmButton.disabled = true;
            setStatus(vehicleStatus, '', '');
            renderVehiclePreview(null);
            resetFamilyOptions();
            updateVehicleSteps();
        }

        function resetQuickSearch() {
            if (hsnInput) hsnInput.value = '';
            if (tsnInput) tsnInput.value = '';
            if (plateInput) plateInput.value = '';
            state.hsnSearchPending = false;
            state.plateSearchPending = false;
            setBusy(hsnButton, false);
            setBusy(plateButton, false);

            setStatus(hsnStatus, '', '');
            setStatus(plateStatus, '', '');

            if (hsnResults) hsnResults.innerHTML = '';
            if (plateResults) plateResults.innerHTML = '';
        }

        async function runHsnSearch() {
            const hsn = (hsnInput && hsnInput.value || '').trim().toUpperCase();
            const tsn = (tsnInput && tsnInput.value || '').trim().toUpperCase();
            if (!hsn || !tsn || state.hsnSearchPending) return;

            state.hsnSearchPending = true;
            setBusy(hsnButton, true);
            setStatus(hsnStatus, readText(root, 'loadingLabel', 'Laden...'), '');
            if (hsnResults) {
                hsnResults.innerHTML = '';
                hsnResults.setAttribute('aria-busy', 'true');
            }

            try {
                setLoading(true);
                const vehicles = await searchHsnTsn(root, hsn, tsn);
                if (!vehicles.length) {
                    setStatus(hsnStatus, readText(root, 'hsnEmptyLabel', 'Keine veroeffentlichten passenden Produkte fuer diese HSN/TSN-Auswahl gefunden.'), 'error');
                    return;
                }

                renderVehicleResults(root, hsnResults, hsnStatus, vehicles, readText(root, 'hsnCountLabel', '{count} Fahrzeug(e) gefunden'));
            } catch (error) {
                setStatus(hsnStatus, resolveUserErrorMessage(root, error, readText(root, 'apiGenericText', 'Die Daten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.')), 'error');
            } finally {
                state.hsnSearchPending = false;
                setBusy(hsnButton, false);
                if (hsnResults) hsnResults.setAttribute('aria-busy', 'false');
                setLoading(false);
            }
        }

        async function runPlateSearch() {
            const plate = (plateInput && plateInput.value || '').trim().toUpperCase();
            if (!plate || state.plateSearchPending) return;

            if ((getConfig(root).plateCountry || 'FR') === 'FR'
                && !/^(?:[A-Z]{2}-[0-9]{3}-[A-Z]{2}|[0-9]{1,4} [A-Z]{2,3} [0-9]{2,3})$/.test(plate)) {
                const isFrench = /^fr(?:-|$)/i.test(document.documentElement.lang);
                const formatMessage = isFrench
                    ? 'Saisissez une plaque française au format AA-123-AA ou 123 AB 75.'
                    : 'Enter a French registration in the format AA-123-AA or 123 AB 75.';
                if (plateResults) plateResults.innerHTML = '';
                setStatus(plateStatus, formatMessage, 'error');
                plateInput.focus();
                return;
            }

            state.plateSearchPending = true;
            setBusy(plateButton, true);
            setStatus(plateStatus, readText(root, 'loadingLabel', 'Laden...'), '');
            if (plateResults) {
                plateResults.innerHTML = '';
                plateResults.setAttribute('aria-busy', 'true');
            }

            try {
                setLoading(true);
                const vehicles = await searchPlate(root, plate);
                if (!vehicles.length) {
                    setStatus(plateStatus, readText(root, 'plateEmptyLabel', 'Keine veroeffentlichten passenden Produkte fuer diese Kennzeichen-Suche gefunden.'), 'error');
                    return;
                }

                renderVehicleResults(root, plateResults, plateStatus, vehicles, readText(root, 'plateCountLabel', '{count} Fahrzeug(e) gefunden'));
            } catch (error) {
                setStatus(plateStatus, resolveUserErrorMessage(root, error, readText(root, 'apiGenericText', 'Die Daten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.')), 'error');
            } finally {
                state.plateSearchPending = false;
                setBusy(plateButton, false);
                if (plateResults) plateResults.setAttribute('aria-busy', 'false');
                setLoading(false);
            }
        }

        async function hydrateSavedVehicle(savedVehicle) {
            if (!makeSelect || !modelSelect || !vehicleSelect || !savedVehicle || !isCompatibleVehicle(savedVehicle)) {
                return;
            }

            const makeId = savedVehicle.makeId || savedVehicle.makeID || '';
            const modelSeriesId = savedVehicle.modelSeriesId || savedVehicle.modelId || '';
            const vehicleId = savedVehicle.vehicleId || savedVehicle.id || '';

            if (!makeId || !modelSeriesId || !vehicleId) {
                return;
            }

            try {
                setLoading(true);

                makeSelect.value = String(makeId);

                state.models = await getModels(root, makeId);
                fillSelect(modelSelect, readText(root, 'modelPlaceholder', 'Modell wählen'), state.models, (item) => item.id, (item) => item.name);
                modelSelect.disabled = false;
                modelSelect.value = String(modelSeriesId);

                state.vehicles = await getVehicles(root, makeId, modelSeriesId);
                fillSelect(vehicleSelect, readText(root, 'vehiclePlaceholder', 'Motor / Typ wählen'), state.vehicles, (item) => item.id, vehicleLabel);
                vehicleSelect.disabled = false;
                vehicleSelect.value = String(vehicleId);

                const matchedVehicle = state.vehicles.find((vehicle) => String(vehicle.id) === String(vehicleId));
                if (matchedVehicle) {
                    if (confirmButton) confirmButton.disabled = false;
                    setStatus(vehicleStatus, '', '');
                    renderVehiclePreview(matchedVehicle);
                    await refreshFamilyOptionsForVehicle(matchedVehicle);
                    setSelectedFamily(root, savedVehicle.family);
                }
            } catch (_) {
                renderVehiclePreview(savedVehicle);
                await refreshFamilyOptionsForVehicle(savedVehicle);
                setSelectedFamily(root, savedVehicle.family);
            } finally {
                updateVehicleSteps();
                setLoading(false);
            }
        }

        function setLoading(isLoading) {
            state.loadingCount = Math.max(0, state.loadingCount + (isLoading ? 1 : -1));
            if (loadingMask) loadingMask.classList.toggle('dfn-hidden', state.loadingCount === 0);
            root.setAttribute('aria-busy', state.loadingCount > 0 ? 'true' : 'false');
        }

        function renderVehiclePreview(vehicle) {
            if (!vehiclePreview) return;

            if (!vehicle) {
                vehiclePreview.classList.add('dfn-hidden');
                if (vehiclePreviewText) vehiclePreviewText.textContent = '';
                if (vehiclePreviewImage) {
                    vehiclePreviewImage.removeAttribute('src');
                    vehiclePreviewImage.alt = '';
                    vehiclePreviewImage.classList.add('dfn-hidden');
                }
                if (vehiclePreviewFallback) {
                    vehiclePreviewFallback.textContent = 'F';
                    vehiclePreviewFallback.classList.remove('dfn-hidden');
                }
                return;
            }

            vehiclePreview.classList.remove('dfn-hidden');
            if (vehiclePreviewText) {
                vehiclePreviewText.textContent = vehicleDisplayName(vehicle);
            }

            if (vehiclePreviewFallback) {
                vehiclePreviewFallback.textContent = firstLetter(vehicle.makeName, 'F');
            }

            if (vehiclePreviewImage) {
                const proxiedImage = getVehicleImageSrc(vehicle);
                if (proxiedImage) {
                    vehiclePreviewImage.src = proxiedImage;
                    vehiclePreviewImage.alt = vehicleDisplayName(vehicle);
                    vehiclePreviewImage.classList.remove('dfn-hidden');
                    if (vehiclePreviewFallback) vehiclePreviewFallback.classList.add('dfn-hidden');
                } else {
                    vehiclePreviewImage.removeAttribute('src');
                    vehiclePreviewImage.alt = '';
                    vehiclePreviewImage.classList.add('dfn-hidden');
                    if (vehiclePreviewFallback) vehiclePreviewFallback.classList.remove('dfn-hidden');
                }
            }
        }

        function resetFamilyOptions() {
            if (!familySelect) return;

            qsa(familySelect, 'option').forEach((option) => {
                option.hidden = false;
                option.disabled = false;
            });
            familySelect.disabled = false;
        }

        async function refreshFamilyOptionsForVehicle(vehicle) {
            if (!familySelect) return;

            const vehicleId = vehicle && (vehicle.id || vehicle.vehicleId);
            const requestId = ++state.familyRequestId;

            if (!vehicleId) {
                resetFamilyOptions();
                return;
            }

            familySelect.disabled = true;

            try {
                const result = await getVehicleResultSummary(root, vehicleId);
                if (requestId !== state.familyRequestId) return;

                const availableFamilies = new Set(
                    (Array.isArray(result.families) ? result.families : [])
                        .map((family) => String(family.family || '').trim().toLowerCase())
                        .filter(Boolean)
                );

                qsa(familySelect, 'option').forEach((option) => {
                    const slug = String(option.dataset.familySlug || '').trim().toLowerCase();
                    const isAvailable = !slug || availableFamilies.has(slug);
                    option.hidden = !isAvailable;
                    option.disabled = !isAvailable;
                });

                const selectedOption = familySelect.selectedOptions && familySelect.selectedOptions[0];
                if (selectedOption && selectedOption.disabled) {
                    familySelect.value = '';
                }
            } catch (_) {
                if (requestId === state.familyRequestId) resetFamilyOptions();
            } finally {
                if (requestId === state.familyRequestId) familySelect.disabled = false;
            }
        }

        async function loadMakesAndHydrate() {
            if (!makeSelect) return;

            makeSelect.disabled = true;
            makeSelect.setAttribute('aria-busy', 'true');
            fillSelect(makeSelect, readText(root, 'loadingLabel', 'Laden...'), [], (item) => item.id, (item) => item.name);
            resetVehicleTree();

            try {
                state.makes = await getMakes(root);
                fillSelect(makeSelect, readText(root, 'makePlaceholder', 'Marke wählen'), state.makes, (item) => item.id, (item) => item.name);
                makeSelect.disabled = false;
                await hydrateSavedVehicle(loadVehicle());
            } catch (error) {
                fillSelect(makeSelect, readText(root, 'noBrandsLabel', 'Aktuell keine verfügbaren Marken im Shop.'), [], () => '', () => '');
                setStatus(vehicleStatus, resolveUserErrorMessage(root, error, readText(root, 'apiGenericText', 'Die Daten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.')), 'error');
            } finally {
                makeSelect.removeAttribute('aria-busy');
            }
        }

        qsa(root, '[data-dfn-tab]').forEach((tab) => {
            tab.addEventListener('click', () => activateTab(root, tab.dataset.dfnTab));
        });

        if (familySelect) {
            familySelect.addEventListener('change', () => {
                setStatus(vehicleStatus, '', '');
            });
        }

        bindSubmitOnEnter([hsnInput, tsnInput], runHsnSearch);
        bindSubmitOnEnter([plateInput], runPlateSearch);

        if (makeSelect) {
            makeSelect.addEventListener('change', async () => {
                fillSelect(modelSelect, readText(root, 'modelPlaceholder', 'Modell wählen'), [], (item) => item.id, (item) => item.name);
                fillSelect(vehicleSelect, readText(root, 'vehiclePlaceholder', 'Motor / Typ wählen'), [], (item) => item.id, vehicleLabel);

                if (modelSelect) modelSelect.disabled = true;
                if (vehicleSelect) vehicleSelect.disabled = true;
                if (confirmButton) confirmButton.disabled = true;
                setStatus(vehicleStatus, '', '');
                renderVehiclePreview(null);
                resetFamilyOptions();
                updateVehicleSteps();

                if (!makeSelect.value) return;

                try {
                    setLoading(true);
                    state.models = await getModels(root, makeSelect.value);
                    if (!state.models.length) {
                        setStatus(vehicleStatus, readText(root, 'noModelsLabel', 'Für diese Marke sind aktuell keine veröffentlichten Modelle verfügbar.'), 'error');
                        return;
                    }

                    fillSelect(modelSelect, readText(root, 'modelPlaceholder', 'Modell wählen'), state.models, (item) => item.id, (item) => item.name);
                    modelSelect.disabled = false;
                    updateVehicleSteps();
                } catch (error) {
                    setStatus(vehicleStatus, resolveUserErrorMessage(root, error, readText(root, 'apiGenericText', 'Die Daten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.')), 'error');
                } finally {
                    setLoading(false);
                }
            });
        }

        if (modelSelect) {
            modelSelect.addEventListener('change', async () => {
                fillSelect(vehicleSelect, readText(root, 'vehiclePlaceholder', 'Motor / Typ wählen'), [], (item) => item.id, vehicleLabel);

                if (vehicleSelect) vehicleSelect.disabled = true;
                if (confirmButton) confirmButton.disabled = true;
                setStatus(vehicleStatus, '', '');
                renderVehiclePreview(null);
                resetFamilyOptions();
                updateVehicleSteps();

                if (!makeSelect || !makeSelect.value || !modelSelect.value) return;

                try {
                    setLoading(true);
                    state.vehicles = await getVehicles(root, makeSelect.value, modelSelect.value);
                    if (!state.vehicles.length) {
                        setStatus(vehicleStatus, readText(root, 'noVehiclesLabel', 'Für dieses Modell sind aktuell keine passenden Fahrzeuge verfügbar.'), 'error');
                        return;
                    }

                    fillSelect(vehicleSelect, readText(root, 'vehiclePlaceholder', 'Motor / Typ wählen'), state.vehicles, (item) => item.id, vehicleLabel);
                    vehicleSelect.disabled = false;
                    updateVehicleSteps();
                } catch (error) {
                    setStatus(vehicleStatus, resolveUserErrorMessage(root, error, readText(root, 'apiGenericText', 'Die Daten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.')), 'error');
                } finally {
                    setLoading(false);
                }
            });
        }

        if (vehicleSelect) {
            vehicleSelect.addEventListener('change', async () => {
                const selectedVehicle = state.vehicles.find((vehicle) => String(vehicle.id) === String(vehicleSelect.value));

                if (confirmButton) confirmButton.disabled = !selectedVehicle;

                if (selectedVehicle) {
                    setStatus(vehicleStatus, '', '');
                    renderVehiclePreview(selectedVehicle);
                    await refreshFamilyOptionsForVehicle(selectedVehicle);
                } else {
                    setStatus(vehicleStatus, '', '');
                    renderVehiclePreview(null);
                    resetFamilyOptions();
                }
                updateVehicleSteps();
            });
        }

        if (confirmButton) {
            confirmButton.addEventListener('click', () => {
                const selectedVehicle = state.vehicles.find((vehicle) => String(vehicle.id) === String(vehicleSelect.value));
                if (!selectedVehicle) return;

                saveVehicle({
                    ...selectedVehicle,
                    vehicleId: selectedVehicle.id,
                    makeId: makeSelect ? makeSelect.value : selectedVehicle.makeId,
                    modelId: selectedVehicle.modelSeriesId,
                    storeId: config.storeId,
                    family: getSelectedFamily(root, selectedVehicle),
                    tecDocProfile: config.profile,
                    vehicleName: vehicleLabel(selectedVehicle)
                });

                window.location.href = buildResultsUrl(root, selectedVehicle);
            });
        }

        if (clearButton) {
            clearButton.addEventListener('click', () => {
                clearVehicle();
                resetVehicleTree();
                resetQuickSearch();
            });
        }

        if (hsnButton) {
            hsnButton.addEventListener('click', runHsnSearch);
        }

        if (plateButton) {
            plateButton.addEventListener('click', runPlateSearch);
        }

        document.addEventListener('dfn:vehicle-selected', (event) => {
            hydrateSavedVehicle(event.detail || loadVehicle());
        });

        document.addEventListener('dfn:vehicle-cleared', () => {
            resetVehicleTree();
            resetQuickSearch();
        });

        if (makeSelect) {
            await loadMakesAndHydrate();
        }
    }

    function initHeaderShell(shell) {
        if (!shell || shell.dataset.dfnHeaderShellReady === 'true') return;
        shell.dataset.dfnHeaderShellReady = 'true';

        const hideIdle = String(shell.dataset.dfnHideIdle || '').toLowerCase() === 'true';
        const summaryRoot = qs(shell, '[data-dfn-role="header-summary"]') || qs(shell, '[data-dfn-role="header-selected"]');
        const idleRoot = qs(shell, '[data-dfn-role="header-idle"]');
        const emptyBar = qs(shell, '[data-dfn-role="header-empty-bar"]') || idleRoot;
        const emptyRoot = qs(shell, '[data-dfn-role="header-empty"]');
        const drawer = qs(shell, '[data-dfn-role="header-drawer"]');
        const popup = qs(shell, '[data-dfn-role="header-popup"]');
        const openButton = qs(shell, '[data-dfn-role="header-open"]');
        const closeButton = qs(shell, '[data-dfn-role="header-close"]');
        const selectedRoot = qs(shell, '[data-dfn-role="header-selected"]');
        const selectedText = qs(shell, '[data-dfn-role="header-selected-text"]');
        const selectedImage = qs(shell, '[data-dfn-role="header-selected-image"]');
        const selectedFallback = qs(shell, '[data-dfn-role="header-selected-fallback"]');
        const changeButton = qs(shell, '[data-dfn-role="header-change"]');
        const clearButton = qs(shell, '[data-dfn-role="header-clear"]');
        const resultsLink = qs(shell, '[data-dfn-role="header-results"]');
        const quickRoot = qs(shell, '[data-dfn-header-quick="true"]');
        const quickHsnInput = qs(shell, '[data-dfn-role="header-hsn-input"]');
        const quickTsnInput = qs(shell, '[data-dfn-role="header-tsn-input"]');
        const quickPlateInput = qs(shell, '[data-dfn-role="header-plate-input"]');
        const quickSearchButton = qs(shell, '[data-dfn-role="header-quick-search"]');
        const quickFeedback = qs(shell, '[data-dfn-role="header-quick-feedback"]');
        const quickStatus = qs(shell, '[data-dfn-role="header-quick-status"]');
        const quickResults = qs(shell, '[data-dfn-role="header-quick-results"]');
        const desktopInlineQuery = window.matchMedia('(min-width: 1400px)');
        const homeFinder = document.querySelector('.dfn-home-finder');
        const storeHeader = shell.closest('store-header');
        const vehicleContext = shell.closest('.header__vehicle-context');
        const popupHome = popup ? popup.parentElement : null;
        const popupNextSibling = popup ? popup.nextElementSibling : null;

        let editing = false;
        let quickSearchPending = false;
        let scrollRenderPending = false;
        let homeFinderPrimaryState = null;
        let homeFinderDocumentBounds = null;

        function captureHomeFinderDocumentBounds() {
            if (!homeFinder) return null;

            const finderRect = homeFinder.getBoundingClientRect();
            const vehicleContextRect = vehicleContext ? vehicleContext.getBoundingClientRect() : null;
            const vehicleContextFlowHeight = Math.max(0, (vehicleContextRect ? vehicleContextRect.height : 0) - 1);

            return {
                top: window.scrollY + finderRect.top - vehicleContextFlowHeight,
                bottom: window.scrollY + finderRect.bottom - vehicleContextFlowHeight
            };
        }

        function measureHomeFinderInPrimaryView() {
            if (!hideIdle || !homeFinder) return false;

            if (!homeFinderDocumentBounds) {
                homeFinderDocumentBounds = captureHomeFinderDocumentBounds();
            }

            const headerRect = storeHeader ? storeHeader.getBoundingClientRect() : null;
            const vehicleContextRect = vehicleContext ? vehicleContext.getBoundingClientRect() : null;
            const vehicleContextHeight = vehicleContextRect ? vehicleContextRect.height : 0;
            const headerOffset = Math.max(0, headerRect ? headerRect.bottom - vehicleContextHeight : 0);
            const finderTop = homeFinderDocumentBounds ? homeFinderDocumentBounds.top - window.scrollY : 0;
            const finderBottom = homeFinderDocumentBounds ? homeFinderDocumentBounds.bottom - window.scrollY : 0;

            return finderBottom > headerOffset + 24 && finderTop < window.innerHeight * 0.72;
        }

        function isHomeFinderInPrimaryView() {
            homeFinderPrimaryState = measureHomeFinderInPrimaryView();
            return homeFinderPrimaryState;
        }

        function requestScrollRender() {
            if (scrollRenderPending) return;

            scrollRenderPending = true;
            window.requestAnimationFrame(() => {
                scrollRenderPending = false;
                const nextHomeFinderPrimaryState = measureHomeFinderInPrimaryView();
                if (nextHomeFinderPrimaryState === homeFinderPrimaryState) return;

                homeFinderPrimaryState = nextHomeFinderPrimaryState;
                renderShell(nextHomeFinderPrimaryState);
            });
        }

        function requestResizeRender() {
            homeFinderDocumentBounds = null;
            requestScrollRender();
        }

        function setPopupPortal(enabled) {
            if (!popup || !popupHome) return;

            if (enabled) {
                if (popup.parentElement !== document.body) {
                    document.body.appendChild(popup);
                }
                return;
            }

            if (popup.parentElement === popupHome) return;

            if (popupNextSibling && popupNextSibling.parentElement === popupHome) {
                popupHome.insertBefore(popup, popupNextSibling);
            } else {
                popupHome.appendChild(popup);
            }
        }

        function hideQuickFeedback() {
            if (quickFeedback) quickFeedback.classList.add('dfn-hidden');
            if (quickResults) quickResults.innerHTML = '';
            if (quickResults) quickResults.setAttribute('aria-busy', 'false');
            setStatus(quickStatus, '', '');
            setBusy(quickSearchButton, false);
            quickSearchPending = false;
        }

        async function runQuickSearch() {
            if (!quickRoot || quickSearchPending) return;

            const isPlateMode = !!quickPlateInput;
            const configRoot = summaryRoot || quickRoot;

            hideQuickFeedback();
            if (quickFeedback) quickFeedback.classList.remove('dfn-hidden');
            if (quickResults) quickResults.setAttribute('aria-busy', 'true');
            setStatus(quickStatus, readText(quickRoot, 'loadingLabel', 'Laden...'), '');
            setBusy(quickSearchButton, true);
            quickSearchPending = true;

            try {
                let vehicles = [];

                if (isPlateMode) {
                    const plate = (quickPlateInput.value || '').trim().toUpperCase();
                    if (!plate) {
                        hideQuickFeedback();
                        return;
                    }

                    vehicles = await searchPlate(quickRoot, plate);

                    if (!vehicles.length) {
                        setStatus(quickStatus, readText(quickRoot, 'plateEmptyLabel', 'Keine veröffentlichten passenden Produkte gefunden.'), 'error');
                        return;
                    }

                    renderVehicleResults(configRoot, quickResults, quickStatus, vehicles, readText(quickRoot, 'plateCountLabel', '{count} Fahrzeug(e) gefunden'));
                    return;
                }

                const hsn = (quickHsnInput && quickHsnInput.value || '').trim().toUpperCase();
                const tsn = (quickTsnInput && quickTsnInput.value || '').trim().toUpperCase();
                if (!hsn || !tsn) {
                    hideQuickFeedback();
                    return;
                }

                vehicles = await searchHsnTsn(quickRoot, hsn, tsn);

                if (!vehicles.length) {
                    setStatus(quickStatus, readText(quickRoot, 'hsnEmptyLabel', 'Keine veröffentlichten passenden Produkte gefunden.'), 'error');
                    return;
                }

                renderVehicleResults(configRoot, quickResults, quickStatus, vehicles, readText(quickRoot, 'hsnCountLabel', '{count} Fahrzeug(e) gefunden'));
            } catch (error) {
                setStatus(quickStatus, resolveUserErrorMessage(quickRoot, error, readText(quickRoot, 'apiGenericText', 'Die Daten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.')), 'error');
            } finally {
                quickSearchPending = false;
                setBusy(quickSearchButton, false);
                if (quickResults) quickResults.setAttribute('aria-busy', 'false');
            }
        }

        function renderShell(homeFinderInPrimaryView) {
            const vehicle = loadVehicleForConfig(getConfig(summaryRoot || shell));
            const desktopInline = desktopInlineQuery.matches;
            const finderInPrimaryView = typeof homeFinderInPrimaryView === 'boolean'
                ? homeFinderInPrimaryView
                : isHomeFinderInPrimaryView();
            const shouldHideIdle = hideIdle && !vehicle && !editing && finderInPrimaryView;
            const hideIdleWhileEditing = editing && !desktopInline;

            if (!vehicle || editing) {
                const popupOpen = !!editing && !desktopInline;
                setPopupPortal(popupOpen);
                document.documentElement.classList.toggle('dfn-popup-open', popupOpen);
                if (emptyBar) emptyBar.classList.toggle('dfn-hidden', shouldHideIdle || hideIdleWhileEditing);
                if (idleRoot) idleRoot.classList.toggle('dfn-hidden', shouldHideIdle || hideIdleWhileEditing);
                shell.classList.toggle('dfn-hidden', shouldHideIdle);
                if (drawer) drawer.classList.add('dfn-hidden');
                if (popup) popup.classList.toggle('dfn-hidden', !(editing && !desktopInline));
                if (emptyRoot) emptyRoot.classList.toggle('dfn-hidden', !editing);
                if (selectedRoot) selectedRoot.classList.add('dfn-hidden');
                return;
            }

            shell.classList.remove('dfn-hidden');
            if (emptyBar) emptyBar.classList.add('dfn-hidden');
            if (idleRoot) idleRoot.classList.add('dfn-hidden');
            if (drawer) drawer.classList.add('dfn-hidden');
            setPopupPortal(false);
            if (popup) popup.classList.add('dfn-hidden');
            document.documentElement.classList.remove('dfn-popup-open');
            if (emptyRoot) emptyRoot.classList.add('dfn-hidden');
            if (selectedRoot) selectedRoot.classList.remove('dfn-hidden');

            if (selectedText) {
                selectedText.textContent = vehicleDisplayName(vehicle);
            }

            if (selectedFallback) {
                selectedFallback.textContent = firstLetter(vehicle.makeName, 'F');
            }

            if (selectedImage) {
                const proxiedImage = getVehicleImageSrc(vehicle);
                if (proxiedImage) {
                    selectedImage.src = proxiedImage;
                    selectedImage.alt = vehicleDisplayName(vehicle);
                    selectedImage.classList.remove('dfn-hidden');
                    if (selectedFallback) selectedFallback.classList.add('dfn-hidden');
                } else {
                    selectedImage.removeAttribute('src');
                    selectedImage.alt = '';
                    selectedImage.classList.add('dfn-hidden');
                    if (selectedFallback) selectedFallback.classList.remove('dfn-hidden');
                }
            }

            if (resultsLink) {
                resultsLink.href = buildResultsUrl(summaryRoot || shell, vehicle);
            }

            hideQuickFeedback();
        }

        if (openButton) {
            openButton.addEventListener('click', () => {
                editing = true;
                if (!desktopInlineQuery.matches) {
                    document.documentElement.classList.add('dfn-popup-open');
                }
                hideQuickFeedback();
                renderShell();
            });
        }

        qsa(shell, '[data-dfn-role="header-close"]').forEach((closeTarget) => {
            closeTarget.addEventListener('click', () => {
                editing = false;
                document.documentElement.classList.remove('dfn-popup-open');
                hideQuickFeedback();
                renderShell();
            });
        });

        if (changeButton) {
            changeButton.addEventListener('click', () => {
                editing = true;
                if (!desktopInlineQuery.matches) {
                    document.documentElement.classList.add('dfn-popup-open');
                }
                hideQuickFeedback();
                renderShell();
            });
        }

        if (clearButton) {
            clearButton.addEventListener('click', () => {
                editing = false;
                document.documentElement.classList.remove('dfn-popup-open');
                clearVehicle();
                hideQuickFeedback();
                renderShell();
            });
        }

        if (quickSearchButton && quickRoot) {
            quickSearchButton.addEventListener('click', runQuickSearch);
        }

        bindSubmitOnEnter([quickHsnInput, quickTsnInput, quickPlateInput], runQuickSearch);

        document.addEventListener('dfn:vehicle-selected', () => {
            editing = false;
            document.documentElement.classList.remove('dfn-popup-open');
            renderShell();
        });

        document.addEventListener('dfn:vehicle-cleared', () => {
            editing = false;
            document.documentElement.classList.remove('dfn-popup-open');
            renderShell();
        });

        document.addEventListener('dfn:open-finder', () => {
            editing = true;
            if (!desktopInlineQuery.matches) {
                document.documentElement.classList.add('dfn-popup-open');
            }
            hideQuickFeedback();
            renderShell();
        });

        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;
            if (!popup || popup.classList.contains('dfn-hidden')) return;

            editing = false;
            document.documentElement.classList.remove('dfn-popup-open');
            renderShell();
        });

        if (desktopInlineQuery && typeof desktopInlineQuery.addEventListener === 'function') {
            desktopInlineQuery.addEventListener('change', () => renderShell());
        }

        if (hideIdle && homeFinder) {
            window.addEventListener('scroll', requestScrollRender, { passive: true });
            window.addEventListener('resize', requestResizeRender);

            if (typeof ResizeObserver === 'function') {
                const homeFinderResizeObserver = new ResizeObserver(requestResizeRender);
                homeFinderResizeObserver.observe(homeFinder);
            }
        }

        renderShell();
    }

    function initAll() {
        qsa(document, '.dfn-home-finder__media').forEach(initHomeMediaSlider);

        qsa(document, '[data-dfn-finder-root="true"]').forEach((root) => {
            initFinder(root).catch((error) => console.error('DFN finder init error:', error));
        });

        qsa(document, '[data-dfn-header-shell="true"]').forEach((shell) => {
            initHeaderShell(shell);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
})();
